/**
   * @ngdoc directive
   * @name adjust.common.directive:includeModalTpl
   * @scope
   * @restrict E
   *
   * @description
   * Include and compile dynamically provided html
   *
   */
function includeModalTpl() {
  'ngInject';
  return {
    restrict: 'E',
    scope: {},
    controllerAs: 'vm',
    controller: 'IncludeModalTplController',
    bindToController: {
      model: '=',
      tpl: '=',
      message: '@'
    }
  };
}

/**
   * @ngdoc controller
   * @name adjust.common.controller:IncludeModalTplController
   *
   * @description
   * All the functionality of the {@link adjust.common.directive:includeModalTpl includeModalTpl} directive
   *
   */
function IncludeModalTplController($scope, $element, $compile, Helper) {
  'ngInject';
  var vm = this;

  Helper.ready(function() {

    var tpl = angular.element(vm.tpl);

    $element.append(tpl);
    $compile(tpl)($scope);

  });
}

export { IncludeModalTplController, includeModalTpl };
